import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Recipe } from '@/types';
import { useI18n } from '@/i18n/I18nContext';

type RecipeCardProps = {
	recipe: Recipe;
	onClick?: () => void;
};

const RecipeCard: React.FC<RecipeCardProps> = ({ recipe, onClick }) => {
	const { t } = useI18n();
	const typeLabel = t.recipes.type[recipe.type] || recipe.type;

	return (
		<Card>
			<CardActionArea onClick={onClick}>
				<CardContent>
					<Stack spacing={2}>
						<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							<Typography variant="h6" fontWeight={700}>
								{recipe.name}
							</Typography>
							<Chip
								label={typeLabel}
								color="primary"
								size="small"
							/>
						</Box>
						{recipe.style && typeof recipe.style === 'string' && (
							<Typography variant="body2" color="text.secondary">
								{t.recipes.style}: {recipe.style}
							</Typography>
						)}
						{recipe.description && (
							<Typography variant="body2" color="text.secondary" sx={{ 
								display: '-webkit-box',
								WebkitLineClamp: 2,
								WebkitBoxOrient: 'vertical',
								overflow: 'hidden'
							}}>
								{recipe.description}
							</Typography>
						)}
						<Stack direction="row" spacing={2} flexWrap="wrap">
							{recipe.abv !== undefined && (
								<Typography variant="caption" color="text.secondary">
									ABV: {recipe.abv.toFixed(1)}%
								</Typography>
							)}
							{recipe.ibu !== undefined && (
								<Typography variant="caption" color="text.secondary">
									IBU: {recipe.ibu}
								</Typography>
							)}
							{recipe.srm !== undefined && (
								<Typography variant="caption" color="text.secondary">
									SRM: {recipe.srm}
								</Typography>
							)}
						</Stack>
					</Stack>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

export default RecipeCard;
